import View from '../view';
import Collection from '../../collection';
import { get } from '../../http/api';
import { hashify } from '../../utils/arrays';
import { asc, desc, } from '../../collection/sort';





export default View.extend( {

    initialize(options = {}) {
        View.prototype.initialize.call( this, options );

        this.collection_ = new Collection();
        this.filtered_ = new Collection();
        this.objectsByDataTables_ = {};
    },

    page_: 1,

    dataTableId_: undefined,

    search_: '',

    sort_: 'name',

    direction_: 'asc',

    serialize() {
        const dataTableId = this.options.datatables && this.options.datatables.current() 
            ? this.options.datatables.current().id 
            : this.options.dataTableId;
    
        if (this.dataTableId_ !== dataTableId)
            this.dataTableId_ = dataTableId,
            this.search_ = '',
            this.page_ = 1;

        if (!dataTableId)
            return {};

        if (this.objectsByDataTables_[dataTableId])
            return sort.call( this, this.objectsByDataTables_[dataTableId] );

        if (this.options.objects)
            return sort.call( this, 
                this.objectsByDataTables_[dataTableId] = new Collection( this.options.objects
                    .toJSON()
                    .filter( obj => obj.layer_id == dataTableId ) ) );

        return get( '/datatables/{id}/features?limit=1000000&pageNumber=1&sysTitle=true&taskId={taskId}&fieldId={fieldId}&datatable_chain={datatable_chain}&master_value={master_value}' )
            .mapsurfer().blocking()
            .map( response => response.features )
            .map( ({ sys_title, ...attrs }, index, features, response) => ({ 
                object_id: attrs[response.pkField], 
                fid: attrs[response.pkField], 
                layer_id: dataTableId,
                ...attrs,
                name: sys_title,
            }) ) 
            .execute( { 
                id: dataTableId, 
                // add taskId/fieldId (if present) & others
                ...this.options.queryParams || {}
            } )
            .then( objects =>
                sort.call( this, 
                    this.objectsByDataTables_[dataTableId] = new Collection( objects ) ) );
    },

    events: {

        'click .-toggle-selected'({currentTarget}) {
            const { name, id: object_id } = currentTarget.dataset;
            const dataTableId = this.dataTableId_;

            const oldSelected = this.model.get( 'selected' );
            const needAppend = currentTarget.checked;
            const newSelected = needAppend
                ? [...oldSelected, { name, object_id, layer_id: dataTableId, }]
                : oldSelected.filter( item => item.layer_id != dataTableId || item.object_id != object_id );

            this.$( '.-toggle-all' )[0]
                .checked = this.filtered_.length > 0 &&
                    newSelected
                        .filter( obj => obj.layer_id == dataTableId )
                        .length == this.filtered_.length;

            this.model.set( 'selected', newSelected );
            setTimeout( () => this.render().then( () => this.focus() ), 
                150 );
        },

        'click .-toggle-all'() {
            const dataTableId = this.dataTableId_;
            const oldSelected = this.model.get( 'selected' );
            const filtered = this.filtered_.toJSON();
            const ids = hashify( filtered.map( obj => obj.id ) );

            // by default drop
            let newSelected = oldSelected.filter( obj =>
                obj.layer_id != dataTableId ||
                obj.layer_id == dataTableId && !ids[obj.object_id] );
            // but: add all 
            if (filtered.some( obj => !obj.chosen ))
                newSelected = [
                    ...oldSelected,
                    ...filtered
                        .filter( obj => !obj.chosen )
                        .map( ({ id, name }) => ({ 
                            object_id: id, 
                            layer_id: dataTableId, 
                            name, }) )
                ];

            this.model.set( 'selected', newSelected );
            setTimeout( () => this.render().then( () => this.focus() ), 
                150 );
        },

        'click .-sort'({currentTarget}) {
            const { direction, sort: column, } = currentTarget.dataset;

            return this.page_ = 1, this.sort_ = column, this.direction_ = direction, 
                this.render();
        },
    
    },

    [View.event( 'ObjectsPaging:page')](page) {
        return this.page_ = page, this.render(); 
    },

    [View.event( 'ObjectsSearch:search')](search) {
        return this.search_ = search, this.page_ = 1, this.render();
    },

} )





function sort(source) {
    // objects is always Collection
    const sorting = 'asc' === this.direction_
        ? asc( source.models, [this.sort_, 'object_id'] )
        : desc( source.models, [this.sort_, 'object_id'] );

    return sorting
        .then( sortedModels => finishSerialize.call( this, new Collection( sortedModels ) ) );
}

function finishSerialize(objects) {
    const objectIds = hashify( (this.model && this.model.get( 'selected' ) || [])
        .filter( ptr => ptr.layer_id == this.dataTableId_ )
        .map( ptr => ptr.object_id ) );

    const searchString = this.search_ && this.search_.toLowerCase() || '';
    const models = (objects instanceof Collection ? objects.toJSON() : objects)
        .map( ({ object_id, ...attrs }) => ({
            id: object_id,
            ...attrs,
            chosen: objectIds[object_id],
        }) )
        .filter( ({ id, name }) => 
            ~(id + '')
                .indexOf( searchString ) ||
            ~(name || '')
                .toLowerCase().indexOf( searchString ) );

    this.filtered_.reset( models );

    const limit = 10;
    this.collection_.reset( models
        .filter( (object, index) => 
            index >= limit * (this.page_ - 1) &&
            index <  limit * this.page_ ) );

    this.collection_.page = this.page_;
    this.collection_.limit = limit;
    this.collection_.total = this.filtered_.length;

    return { 
        collection: this.collection_,
        multiple: this.options.multiple,
        allSelected: 
            models.every( object => object.chosen ) &&
            models.length > 0,
        searchString: this.search_,
        objectsSort: this.sort_, objectsDirection: this.direction_,
        amountEditable: this.options.amountEditable,
    };
}



// WEBPACK FOOTER //
// ./src/js/view/layers/objects.js